// http://stackoverflow.com/a/5535472/176758
export default function trueRound (value, digits) {
  return (Math.round((value * Math.pow(10, digits)).toFixed(digits - 1)) /
    Math.pow(10, digits)).toFixed(digits)
}
